import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label"]

  connect() {
    this.applyTheme()
  }

  toggle() {
    const current = document.documentElement.getAttribute("data-theme")
    const next = current === "dark" ? "light" : "dark"
    document.documentElement.setAttribute("data-theme", next)
    localStorage.setItem("theme", next)
    this.updateUI(next)
    document.dispatchEvent(new CustomEvent("theme-changed", { detail: { theme: next } }))
  }

  applyTheme() {
    const saved = localStorage.getItem("theme")
    const theme = saved || "dark"
    document.documentElement.setAttribute("data-theme", theme)
    this.updateUI(theme)
  }

  updateUI(theme) {
    const el = this.element.querySelector(".theme-icon")
    if (el) {
      el.innerHTML = theme === "dark"
        ? '<iconify-icon icon="solar:sun-bold"></iconify-icon>'
        : '<iconify-icon icon="solar:moon-bold"></iconify-icon>'
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = theme === "dark" ? "Modo Claro" : "Modo Escuro"
    }
  }
}
